import React, { useCallback, useEffect, useState } from 'react';
import { toast } from "react-toastify";
import { Otp } from './Otp';

function OtpContainer({ onSubmit, loading }) {
	const [code, setCode] = useState('');

	const isValidCode = useCallback((str) => {
		return str.length === 5 && /^\d+$/.test(str);
	}, []);

	const handleChange = useCallback((event) => {
		setCode(event.target.value);
	}, []);

	useEffect(() => {
		if (!code || code.length !== 5) {
			return;
		}

		if (!isValidCode(code)) {
			toast.error("Código inválido!");
			return;
		}

		onSubmit(code);
	}, [code, isValidCode, onSubmit]);

	return (
		<Otp
			loading={loading}
			onChange={handleChange}
		/>
	);
}

export default OtpContainer;
